<div class="bool" [ngClass]="{ 'light': lightUI }">
  <ion-button expand="block" [ngClass]="{ 'checked': trueValue === model }" (click)="writeValue(trueValue)">
    {{ trueText }}
  </ion-button>
  <ion-button expand="block" [ngClass]="{ 'checked': falseValue === model }" (click)="writeValue(falseValue)">
    {{ falseText }}
  </ion-button>
</div>
